"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Image = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5,5 L19,5 C19.5522847,5 20,5.44771525 20,6 L20,18 C20,18.5522847 19.5522847,19 19,19 L5,19 C4.44771525,19 4,18.5522847 4,18 L4,6 C4,5.44771525 4.44771525,5 5,5 Z M19,14.123 L19,6 L5,6 L5,14.282 L7.19261538,12.63 C7.37784615,12.49 7.63846154,12.482 7.83553846,12.605 L9.68000031,13.8800001 L14.2744615,9.535 C14.3832308,9.435 14.5350769,9.374 14.6847692,9.391 C14.8376923,9.398 14.9787692,9.466 15.0746154,9.577 L19,14.123 Z M19,18 L19,15.722 L14.6093846,10.637 L10.1300001,14.778 C9.94584627,14.948 9.55430784,14.973 9.34000015,14.837 L7.55876923,13.642 L5,15.57 L5,18 L19,18 Z M8,9 C8,8.447 8.448,8 9,8 C9.552,8 10,8.447 10,9 C10,9.553 9.552,10 9,10 C8.448,10 8,9.553 8,9 Z" })));
};
Image.displayName = 'Image';
exports.default = Image;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Image.js.map